export const CDN_URL = 'https://cdn.migros.ch';
export const MigrosOnlineTheme = {
  name: 'Migros Online Theme',
  themeId: 'migrosOnline',
  colors: {
    brand: {
      primary: {
        10: '#FFFFFF',
        90: '#F5F5F5',
        100: '#FF6600'
      },
      secondary: {
        100: '#B24800' /* MigrosOnline MOrange 800 */
      },
      accent: {
        100: '#FF6600' /* MigrosOnline MOrange 600 */
      },
      text: {
        100: '#333333'
      },
      textInverted: {
        100: '#FFFFFF'
      },
      negative: {
        50: '#FEE1DC' /* MigrosOnline MRed 300 */,
        100: '#E02805' /* MigrosOnline MRed 700 */
      },
      positive: {
        100: '#52A63F' /* MigrosOnline MGreen 700 */
      },
      highlight: {
        100: '#0E95D8' /* MigrosOnline MBlue 700 */
      },
      altHighlight: {
        100: '#57C1F4' /* MigrosOnline MBlue 500 */
      },
      background: {
        100: '#FFFFFF'
      },
      backgroundHighlight: {
        100: '#DDF2FD' /* MigrosOnline MBlue 200 */
      },
      grayout: {
        100: '#E0E0E0' /* MigrosOnline MGrey 300 */
      },
      alternative: {
        100: '#FF6600'
      }
    },
    tints: {
      gray: {
        5: '#F5F5F5' /* MigrosOnline MGrey 100 */,
        10: '#F5F5F5' /* MigrosOnline MGrey 100 */,
        25: '#EDEDED' /* MigrosOnline MGrey 200 */,
        30: '#E0E0E0' /* MigrosOnline MGrey 300 */,
        40: '#D9D9D9',
        45: '#cfcac7',
        50: '#BFBFBF' /* MigrosOnline MGrey 400 */,
        60: '#949494',
        75: '#888888',
        80: '#808080' /* MigrosOnline MGrey 600 */,
        90: '#737373' /* MigrosOnline MGrey 700 */,
        100: '#595959' /* MigrosOnline MGrey 800 */
      },
      white: {
        100: '#FFFFFF'
      },
      black: {
        85: '#333333',
        90: '#333333' /* MigrosOnline MBlack */
      }
    }
  },
  backgrounds: {
    tile: '#000'
  },
  shadows: {
    base: '0px 0px 12px 0px #3333331A' /* MigrosOnline Shadow Medium */
  },
  fonts: {
    families: {
      /* Adjusted for MO to match variables 'text' and 'display' */
      text: 'text, "Helvetica Now Text", "Helvetica", arial, sans-serif',
      condensed: 'text, "Helvetica Now Text", "Helvetica", arial, sans-serif',
      notes: '"MarketWeb", text, "Helvetica Now Text", "Helvetica", arial, sans-serif',
      heading: 'display, "Helvetica Now Display", "Helvetica", arial, sans-serif',
      subHeading: 'display, "Helvetica Now Display", "Helvetica", arial, sans-serif',
      display: 'display, "Helvetica Now Display", "Helvetica", arial, sans-serif',
      articleText: 'text, "Helvetica Now Text", "Helvetica", arial, sans-serif',
      articleHeading: 'text, "Helvetica Now Text", "Helvetica", arial, sans-serif',
      articlePrice: 'display, "Helvetica Now Display", "Helvetica", arial, sans-serif'
    },
    weights: {
      /* Adjusted for MO to match Helvetica Now family */
      thin: 200,
      light: 300,
      regular: 400,
      medium: 500,
      semiBold: 700,
      bold: 800,
      bolder: 900
    }
  },
  borderRadiuses: {
    xsmall: '2px',
    small: '4px',
    medium: '8px' /* MigrosOnline cornerRadius/medium */,
    large: '16px' /* MigrosOnline cornerRadius/large */
  }
};